/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Template_Default_LocaleInputs */

const en_error_template_default_locale = /** @type {(inputs: Error_Template_Default_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The English text is the one every other language falls back to: it cannot be turned off or deleted.`)
};

/**
* | output |
* | --- |
* | "The English text is the one every other language falls back to: it cannot be turned off or deleted." |
*
* @param {Error_Template_Default_LocaleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_template_default_locale = /** @type {((inputs?: Error_Template_Default_LocaleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Template_Default_LocaleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_template_default_locale(inputs)
});